// components/PartnersSection.tsx
import React from "react";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import styles from "./Styles/PartnersSection.module.css";

const onboardingSteps = [
  "Install the App",
  "Get Started",
  "Submit Your Documents",
  "Confirm Your Identity",
  "Verification Complete",
  "You're All Set!",
];

const PartnersSection: React.FC = () => {
  const lastStepIndex = onboardingSteps.length - 1;

  return (
    <section className={styles.partnersSection}>
      <div className={styles.leftPane}>
        <span className={styles.eyebrow}>Partnership</span>
        <h1 className={styles.heading}>
          Drive with <span className={styles.highlight}>Sprinterwave</span>
        </h1>
        <p className={styles.description}>
          Join Sprinterwave as a driver-partner and start earning on your own
          terms. Whether you're looking to make extra income or drive
          full-time, Sprinterwave gives you the tools to succeed. Use your
          own car, set your schedule, and connect with riders through our
          easy-to-use platform.
        </p>

        <Link to="/rider" className={styles.ctaLink}>
          <button className={styles.ctaButton}>Become a Driver →</button>
        </Link>
      </div>

      <div className={styles.rightPane}>
        <span className={styles.timelineEyebrow}>How onboarding works</span>
        <ol className={styles.timeline}>
          {onboardingSteps.map((name, index) => {
            const isLast = index === lastStepIndex;
            return (
              <li key={name} className={styles.timelineItem}>
                <span
                  className={`${styles.timelineDot} ${
                    isLast ? styles.timelineDotDone : ""
                  }`}
                >
                  {isLast ? <FaCheck size={11} /> : index + 1}
                </span>
                <span className={styles.timelineLabel}>{name}</span>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default PartnersSection;